module.exports = __webpack_public_path__ + "static/billsby-compliance-4df2dd642b3cf74c614a4747f05f3107.svg";